<div class="news-no-feed-container">
  <img
    class="news-no-feed-img"
    src="wealth-assets/svg/disconnected.svg"
  />
  <div class="news-no-feed-description">
    <span>سرویس اخبار در دسترس نیست</span>
    <span>برای ادامه فرایند دقایقی دیگر دوباره تلاش کنید.</span>
  </div>
  <div class="news-no-feed-button">
    <ngx-button
      [disabled]="inProgress"
      (clickHandler)="refetchNews()"
      [size]="'medium'"
      [style]="'tinted-on-elevated'"
    >
      @if (inProgress) {
        <ngx-count-down
          [timeInSeconds]="5"
          [type]="'mm:ss'"
          (finished)="onTimerStopped()"
        ></ngx-count-down>
      } @else {
        تلاش دوباره
      }
    </ngx-button>
  </div>
</div>
